/*!
 * Solva — PDP gallery slider
 * Transform-based carousel: arrows, thumbnail sync, finger-follow swipe.
 * Markup: [data-solva-gallery] > [data-solva-gallery-track] > [data-solva-gallery-slide]
 * Controls: [data-solva-gallery-prev/next], [data-solva-gallery-thumb]
 */
(function () {
  if (typeof document === 'undefined') return;

  function initGallery(gallery) {
    var track = gallery.querySelector('[data-solva-gallery-track]');
    if (!track) return; // single image / fallback — nothing to slide
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-solva-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-solva-gallery-thumb]'));
    var prev = gallery.querySelector('[data-solva-gallery-prev]');
    var next = gallery.querySelector('[data-solva-gallery-next]');
    var count = slides.length;
    if (count < 1 || gallery.dataset.galleryReady === '1') return;
    gallery.dataset.galleryReady = '1';

    var index = 0;

    function centerThumb(i) {
      var btn = thumbs[i];
      if (!btn) return;
      var li = btn.parentNode;
      var rail = li && li.parentNode;
      if (!rail || rail.scrollWidth <= rail.clientWidth) return;
      var target = li.offsetLeft - (rail.clientWidth - li.offsetWidth) / 2;
      rail.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }

    function render(animate) {
      if (!animate) track.style.transition = 'none';
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      if (!animate) { void track.offsetWidth; track.style.transition = ''; }
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === count - 1;
      centerThumb(index);
    }

    function goTo(i) {
      index = Math.max(0, Math.min(count - 1, i));
      render(true);
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });

    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') goTo(index - 1);
      if (e.key === 'ArrowRight') goTo(index + 1);
    });

    // Finger-follow swipe with axis detection (never blocks vertical scroll)
    var startX = 0, startY = 0, dx = 0, width = 1;
    var dragging = false, decided = false, horizontal = false;

    track.addEventListener('touchstart', function (e) {
      if (count < 2) return;
      dragging = true; decided = false; horizontal = false; dx = 0;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      width = track.offsetWidth || 1;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var ddx = e.touches[0].clientX - startX;
      var ddy = e.touches[0].clientY - startY;
      if (!decided) {
        if (Math.abs(ddx) < 6 && Math.abs(ddy) < 6) return;
        decided = true;
        horizontal = Math.abs(ddx) > Math.abs(ddy);
        if (horizontal) track.style.transition = 'none';
      }
      if (!horizontal) return;
      dx = ddx;
      track.style.transform = 'translateX(' + ((-index * 100) + (dx / width * 100)) + '%)';
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      if (!horizontal) return;
      track.style.transition = '';
      var threshold = width * 0.15;
      if (dx <= -threshold) index = Math.min(count - 1, index + 1);
      else if (dx >= threshold) index = Math.max(0, index - 1);
      render(true);
      dx = 0;
    }, { passive: true });

    render(false);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.slice.call(scope.querySelectorAll('[data-solva-gallery]')).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init inside the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
